import * as Long from "long";
import { selectBalancingPVPMapMaxUnitsProduction, selectBalancingPVPMapMinUnitsProduction, } from "../balancingSelectors/selectBalancingPvPMapDefinitions";
import { EventType } from "../features/balancing/types/BalancingCore";
import { selectRunningEventInfosByEventType } from "./selectEventInfo";
import { selectOwnPlayerId } from "./selectPlayerInfo";
export var selectPVPUnitAmountByDollars = function (state, dollarAmount) {
    var runningEventMapId = selectCurrentRunningPvPEventMapId(state);
    if (runningEventMapId == undefined) {
        return Long.ZERO;
    }
    var minUnits = selectBalancingPVPMapMinUnitsProduction(runningEventMapId);
    var variableUnits = selectVariablePVPUnits(state, dollarAmount);
    return variableUnits.add(minUnits);
};
export var selectVariablePVPUnits = function (state, dollarAmount) {
    var runningEventMapId = selectCurrentRunningPvPEventMapId(state);
    if (runningEventMapId == undefined) {
        return Long.ZERO;
    }
    var convertedDollars = Long.fromValue(dollarAmount);
    var playerId = selectOwnPlayerId(state);
    var minUnits = selectBalancingPVPMapMinUnitsProduction(runningEventMapId);
    var maxUnits = selectBalancingPVPMapMaxUnitsProduction(runningEventMapId);
    var unitsSpan = maxUnits - minUnits + 1;
    var variableNumber = playerId.add(convertedDollars);
    return variableNumber.mod(unitsSpan);
};
export var selectCurrentRunningPvPEventMapId = function (state) {
    var runningEvents = selectRunningEventInfosByEventType(state, EventType.PvpMapLeague);
    return runningEvents && runningEvents[0] && runningEvents[0].balancing
        ? runningEvents[0].balancing.mapId
        : undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectPVP.ts
// module id = 413
// module chunks = 3